import { Navigate } from 'react-router-dom';
import { useStore } from '@hooks/useStore';
import { FeatureFlagName } from '@/interfaces/User.interface';
import { ProtectedRouteProps } from './types';
import { AuthSessionGate } from './AuthSessionGate';

interface FeatureProtectedProps extends ProtectedRouteProps {
  flag: FeatureFlagName;
}

const FeatureProtected = ({
  permissions,
  element,
  flag
}: FeatureProtectedProps) => {
  const { authStore } = useStore();
  const { hasPermission, hasFeature } = authStore;

  const canAccessFeature = hasFeature(flag) && hasPermission(permissions);

  return (
    <AuthSessionGate>
      {canAccessFeature ? element ?? null : (
        <Navigate to="/dashboard" replace />
      )}
    </AuthSessionGate>
  );
};

export default FeatureProtected;
